import type { Customer, MyHana } from './types';

/** Chữ viết tắt 2 ký tự của avatar tròn (board: DAVID → DA, PhuongHT → PH). */
export const abbr = (s: string): string => s.slice(0, 2).toUpperCase();

/** Chữ cái avatar vuông: chữ đầu của tối đa 2 từ cuối (từ ≥ 2 ký tự); không có từ nào thì chữ đầu tên. */
export function initials(name: string): string {
  const w = name.split(' ').filter((x) => x.length > 1).slice(-2).map((x) => x[0]).join('').toUpperCase();
  return w || name.slice(0, 1).toUpperCase();
}

/** "21/Oct/2026" → "21/Oct" (cột Cập nhật). */
export const shortDate = (d: string): string => d.split('/').slice(0, 2).join('/');

/** Nhãn ngắn myHANA ở chip: "Đã có · 3 user" → "3", "Chờ BOD duyệt" → "Chờ BOD". */
export const myChip = (my: MyHana): { text: string; tone: 'ok' | 'warn' | 'none' } =>
  my === 'wait' ? { text: 'Chờ BOD', tone: 'warn' } : my === 'no' ? { text: 'Chưa có', tone: 'none' } : { text: my.slice(2), tone: 'ok' };

export type LimitState = 'prepaid' | 'over' | 'within';
/** Cột "Hạn mức · còn lại" khi người xem KHÔNG có quyền tiền: chỉ trạng thái, không số tiền. */
export const limitState = (c: Customer): LimitState => (!c.credit.limit ? 'prepaid' : c.credit.used > c.credit.limit ? 'over' : 'within');
export const LIMIT_LABEL: Record<LimitState, string> = { prepaid: 'Trả trước', over: 'Vượt hạn mức', within: 'Trong hạn mức' };

/** Giữ DO: vượt hạn mức hoặc quá hạn trên 100 triệu (đúng board). */
export const holdsDo = (c: Customer): boolean => limitState(c) === 'over' || c.credit.overdue > 100;

/** Khách cần chú ý (số đỏ ở đầu thanh): quá hạn hoặc vượt hạn mức. */
export const attention = (c: Customer): boolean => c.credit.overdue > 0 || limitState(c) === 'over';
